import React, { useState } from "react";
import { Box, CssBaseline, Drawer, useTheme, useMediaQuery } from "@mui/material";
import Footer from "./footer";
import Header from "./header";
import Sidebar from "./sidebar";

function Layout2({ children }: any) {
  const [collapsed, setCollapsed] = useState(false);
  const drawerWidth = collapsed ? 80 : 260; // Use 260px for DJobsite feel
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", backgroundColor: "#F4F7FE" }}>
      <CssBaseline />

      {/* Sidebar - Spans full height on the left */}
      <Box
        component="nav"
        sx={{
          width: isMobile ? 0 : drawerWidth,
          flexShrink: 0,
          transition: "width 0.3s ease-in-out",
        }}
      >
        <Drawer
          variant={isMobile ? "temporary" : "permanent"}
          open={isMobile ? !collapsed : true}
          onClose={() => setCollapsed(true)}
          sx={{
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              boxSizing: "border-box",
              overflowX: "hidden",
              transition: "width 0.3s ease-in-out",
              backgroundColor: "#1A202C", // Dark theme for DJobsite
              borderRight: "none",
              color: "#ffffff",
            },
          }}
        >
          <Sidebar collapsed={collapsed && !isMobile} />
        </Drawer>
      </Box>

      {/* Main Content Area (Header + Children) */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
          width: isMobile ? "100%" : `calc(100% - ${drawerWidth}px)`,
          transition: "width 0.3s ease-in-out, margin 0.3s ease-in-out",
        }}
      >
        {/* Header - Sits to the right of the sidebar */}
        <Header handleDrawerToggle={toggleSidebar} collapsed={collapsed && !isMobile} />

        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 3,
            overflowX: "hidden",
            overflowY: "auto",
          }}
        >
          {children}
        </Box>

        <Footer />
      </Box>
    </Box>
  );
}

export default Layout2;
